import { useContext } from 'react';
import { LwpContext } from './provider';

export default function useLwp() {
  const context = useContext(LwpContext);
  if (!context) throw new Error('useLwp must be used within LwpProvider');
  return context;
}